"use strict";
/* eslint-disable functional/no-classes */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeDuration = void 0;
/**
 * Represents a duration of time in milliseconds.
 *
 * Inspired by Joda Time's Duration class.
 */
class TimeDuration {
    milliseconds;
    /**
     * A Duration instance representing one second.
     */
    static oneSecond = new TimeDuration(1_000);
    /**
     * A Duration instance representing one minute.
     */
    static oneMinute = new TimeDuration(60_000);
    /**
     * A Duration instance representing one hour.
     */
    static oneHour = new TimeDuration(3_600_000);
    /**
     * A Duration instance representing one day.
     */
    static oneDay = new TimeDuration(86_400_000);
    /**
     * A Duration instance representing one week.
     */
    static oneWeek = new TimeDuration(604_800_000);
    /**
     * A Duration instance representing one year.
     */
    static oneYear = new TimeDuration(31_536_000_000);
    /**
     * Creates a new TimeDuration instance from a number of years, days, hours, minutes, seconds and milliseconds.
     * All arguments are optional and default to 0.
     */
    static fromParts({ years = 0, days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0 }) {
        const totalMilliseconds = milliseconds +
            seconds * this.oneSecond.milliseconds +
            minutes * this.oneMinute.milliseconds +
            hours * this.oneHour.milliseconds +
            days * this.oneDay.milliseconds +
            years * this.oneYear.milliseconds;
        return new TimeDuration(totalMilliseconds);
    }
    /**
     * Create a new Duration instance.
     *
     * @param milliseconds - The duration in milliseconds.
     */
    constructor(milliseconds) {
        this.milliseconds = milliseconds;
    }
    /**
     * Get the duration in seconds.
     */
    get asSeconds() {
        return this.milliseconds / TimeDuration.oneSecond.milliseconds;
    }
    /**
     * Get the duration in minutes.
     */
    get asMinutes() {
        return this.asSeconds / 60;
    }
    /**
     * Get the duration in hours.
     */
    get asHours() {
        return this.asMinutes / 60;
    }
    /**
     * Get the duration in days.
     */
    get asDays() {
        return this.asHours / 24;
    }
    /**
     * Get the duration in weeks.
     */
    get asWeeks() {
        return this.asDays / 7;
    }
    /**
     * Get the duration in years.
     *
     * This is a rough estimate based on 365 days per year.
     */
    get asYears() {
        return this.asDays / 365;
    }
}
exports.TimeDuration = TimeDuration;
